import { Link } from "react-router-dom";

import logo from "../assets/logo.png";

const DiscordIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor"><path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128c.12-.098.246-.198.373-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246-.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03z" /></svg>
);

const linkClass = "block text-sm text-zinc-400 hover:text-amber-400 transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 rounded";

const linkLabelClass = "text-[10px] font-black uppercase tracking-[0.25em] text-slate-500 mb-4";

export const Footer = ({ withGradient = false, variant = "transparent" }) => {
  const isBlack = variant === "black";
  const socials = [
    { href: "https://discord.com/invite/aKKGjtwuFt", label: "Discord", icon: <DiscordIcon />, color: "hover:text-[#5865F2] hover:border-[#5865F2]/40" },
    { href: "https://trucklinemp.com/vtc/@openpipeclub", label: "TrucklineMP", icon: <img src="/images/logos/trucklinemp.png" alt="" className="w-4 h-4 object-contain" />, color: "hover:text-[#00ff9d] hover:border-[#00ff9d]/40" },
    { href: "https://truckersmp.com/vtc/85133", label: "TruckersMP", icon: <img src="/images/logos/truckersmp.png" alt="" className="w-4 h-4 object-contain" />, color: "hover:text-[#e74c3c] hover:border-[#e74c3c]/40" },
  ];

  return (
    <footer
      className={`relative z-10 border-t ${isBlack ? "bg-black border-zinc-900/60" : "bg-transparent border-white/5"}`}
      data-testid="site-footer"
    >
      {withGradient && (
        <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-t from-transparent to-black" />
      )}

      <div className="max-w-[1450px] mx-auto px-4 sm:px-6 lg:px-8 py-14 relative">
        <div className="grid gap-10 md:grid-cols-[1.6fr_1fr_1fr]">

          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={logo} alt="Open Pipe Club" className="w-10 h-10 rounded-lg object-contain" />
              <span className="font-['Unbounded'] font-black text-sm text-white uppercase tracking-[0.2em]">
                Open Pipe Club
              </span>
            </div>
            <p className="text-sm text-zinc-500 leading-relaxed max-w-xs mb-5">
              Dutch & Nordic Truckstyle. Driving with style.
            </p>
            <div className="flex items-center gap-2">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className={`text-zinc-500 transition-colors duration-200 p-2.5 rounded-full border border-white/10 bg-white/[0.02] ${s.color}`}
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <p className={linkLabelClass}>Navigation</p>
            <div className="space-y-3.5">
              <Link to="/" className={linkClass}>Home</Link>
              <Link to="/news" className={linkClass}>News</Link>
              <Link to="/events" className={linkClass}>Events</Link>
              <Link to="/team" className={linkClass}>Team</Link>
              <Link to="/gallery" className={linkClass}>Galerie</Link>
            </div>
          </div>

          {/* Club */}
          <div>
            <p className={linkLabelClass}>Club</p>
            <div className="space-y-3.5">
              <Link to="/tracker" className={linkClass}>Tracker</Link>
              <Link to="/regelwerk" className={linkClass}>Regelwerk</Link>
              <Link to="/map" className={linkClass}>Live-Karte</Link>
              <Link to="/apply" className={linkClass}>Bewerben</Link>
              <Link to="/drivershub/login" className={linkClass}>Drivers Hub</Link>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-zinc-900/60 flex flex-col sm:flex-row items-center justify-between gap-3 text-center sm:text-left">
          <p className="text-[10px] text-zinc-600 font-bold uppercase tracking-widest">
            &copy; {new Date().getFullYear()} Open-Pipe-Club. Alle Rechte vorbehalten.
          </p>
          <p className="text-[10px] text-zinc-700 tracking-wide max-w-md leading-relaxed select-none">
            Diese Webseite steht in keinerlei Verbindung mit SCS Software, TruckersMP oder TrucklineMP.
          </p>
        </div>
      </div>
    </footer>
  );
};
